import { VStack } from '@chakra-ui/react';
import { HomeHeading } from '@/components/rulesMarketing/HomeHeading';
import { RulesPageContent } from './RulesPageContent';

export function RulesExamplesSection() {
  return (
    <VStack align='stretch' spacing={{ base: 6, md: 8 }} w='full'>
      <HomeHeading>Examples</HomeHeading>
      <RulesPageContent tabsAtBottom />
    </VStack>
  );
}
